import { Link } from "react-router-dom"
import Logo from "./tuskylogo.png"
function Nav() {
    return (
        <div className="header">
        <img src={Logo} className='logo'></img>
        <h2>TUSCARORA TIME</h2>
        
        <ul>
            <Link to="/">
            <li>Tusky Time</li>
            </Link>
         
        </ul>
      </div>
    )
}
export default Nav